import { useUserService } from "../services";

export function useGuestAccept() {
  const service = useUserService();

  return (
    contactId: string,
    meetingId: string,
    orgId: string,
    turnstileToken?: string | null,
  ): Promise<void> => {
    const body: Record<string, string> = {
      a: "accept",
      c: contactId,
      m: meetingId,
      o: orgId,
    };
    if (turnstileToken) {
      body.tt = turnstileToken;
    }
    return service
      .post(`/api/meeting/guest/action`)
      .send(body)
      .then((res: Response) => res.body);
  };
}
